import React from "react";
import { Download, Share, Plus } from "lucide-react";
import logoUrl from "@/assets/fightfund-logo.png";
import { usePwaInstall } from "@/hooks/usePwaInstall";

/* Inline, contextual "Add to Home Screen" nudge for high-intent moments
   (e.g. right after a donation or a follow). Renders nothing when the app
   is already installed or the device can't install. */
export default function InstallNudge({
  headline = "Keep FightFund one tap away",
  sub = "Add it to your home screen for instant access to updates.",
  testid = "install-nudge",
}) {
  const { installable, iosSafari, promptInstall } = usePwaInstall();
  if (!installable && !iosSafari) return null;
  const ios = !installable && iosSafari;

  return (
    <div data-testid={testid} className="mt-4 rounded-xl border border-ff-border bg-[#F3F4F6] p-4 text-left">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-ff-border bg-white">
          <img src={logoUrl} alt="FightFund" className="h-7 w-7 object-contain" />
        </span>
        <div className="min-w-0">
          <div className="font-heading text-sm font-bold text-ff-blue">{headline}</div>
          {ios ? (
            <p className="mt-0.5 text-xs leading-relaxed text-ff-medium">
              Tap <Share className="inline h-3.5 w-3.5 -translate-y-0.5 text-ff-blue" /> then{" "}
              <span className="font-semibold text-ff-blue">
                Add to Home Screen <Plus className="inline h-3 w-3 -translate-y-0.5" />
              </span>
              .
            </p>
          ) : (
            <p className="mt-0.5 text-xs leading-relaxed text-ff-medium">{sub}</p>
          )}
        </div>
      </div>
      {!ios && (
        <button
          data-testid={`${testid}-button`}
          onClick={promptInstall}
          className="mt-3 flex w-full items-center justify-center gap-2 rounded-lg bg-ff-blue px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-ff-blue/90"
        >
          <Download className="h-4 w-4" /> Add to Home Screen
        </button>
      )}
    </div>
  );
}
